import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { loginProviderDirectory, setProviderDirectoryTokenData } from '../../store/features/userSlice';

const WithAuth = (WrappedComponent) => {
    return function AuthComponent(props) {
        const tokenData = useSelector((state) => state.user.providerDirectoryTokenData);
        const dispatch = useDispatch();

        const getValidProviderDirectoryToken = (payload) => {
            let expireDate = (tokenData?.created == null ? null : tokenData.created + (tokenData.expires_in * 1000) );

            if (expireDate < Date.now() || expireDate == null) {
                return dispatch(loginProviderDirectory({
                    callback: (response) => {
                        let dateNow = Date.now();
                        dispatch(setProviderDirectoryTokenData({
                            ...response,
                            created: dateNow
                        }));

                        payload.callback(response);
                    },
                    catch: (error) => {
                        console.log('Error during token exchange for Provider Directory:', error);
                        payload.catch(error);
                    }
                })
                );
            }

            payload.callback(tokenData);
        };

        return (
            <>
                <WrappedComponent {...props} getValidProviderDirectoryToken={getValidProviderDirectoryToken} />
            </>
        );
    };
}

export default WithAuth;
